import type * as Types from '../../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type WeddingCodeBannerBookableHotelQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type WeddingCodeBannerBookableHotelQuery = {
  __typename?: 'Query';
  event?: {
    __typename?: 'Event';
    id: string;
    travelSettings?: { __typename?: 'TravelSettings'; showWeddingCodeBanner?: boolean | null } | null;
    accommodationPlacesV2: Array<{
      __typename?: 'AccommodationPlaceV2';
      id: string;
      type?: Types.AccommodationPlaceType | null;
      isCustomLinkEnabled?: boolean | null;
      isFromAccommodationCatalog: boolean;
      accommodationRoomBlock?: { __typename?: 'AccommodationPlaceRoomBlock'; status: Types.AccommodationPlaceRoomBlockStatus } | null;
    }>;
  } | null;
};

export const WeddingCodeBannerBookableHotelDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'WeddingCodeBannerBookableHotel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'event' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'travelSettings' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'showWeddingCodeBanner' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accommodationPlacesV2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isCustomLinkEnabled' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isFromAccommodationCatalog' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accommodationRoomBlock' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'status' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useWeddingCodeBannerBookableHotelQuery__
 *
 * To run a query within a React component, call `useWeddingCodeBannerBookableHotelQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeddingCodeBannerBookableHotelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeddingCodeBannerBookableHotelQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useWeddingCodeBannerBookableHotelQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<WeddingCodeBannerBookableHotelQuery, WeddingCodeBannerBookableHotelQueryVariables>,
) {
  return ApolloReactHooks.useQuery<WeddingCodeBannerBookableHotelQuery, WeddingCodeBannerBookableHotelQueryVariables>(WeddingCodeBannerBookableHotelDocument, baseOptions);
}
export function useWeddingCodeBannerBookableHotelLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<WeddingCodeBannerBookableHotelQuery, WeddingCodeBannerBookableHotelQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<WeddingCodeBannerBookableHotelQuery, WeddingCodeBannerBookableHotelQueryVariables>(WeddingCodeBannerBookableHotelDocument, baseOptions);
}
export type WeddingCodeBannerBookableHotelQueryHookResult = ReturnType<typeof useWeddingCodeBannerBookableHotelQuery>;
export type WeddingCodeBannerBookableHotelLazyQueryHookResult = ReturnType<typeof useWeddingCodeBannerBookableHotelLazyQuery>;
export type WeddingCodeBannerBookableHotelQueryResult = Apollo.QueryResult<WeddingCodeBannerBookableHotelQuery, WeddingCodeBannerBookableHotelQueryVariables>;
